<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            System error - contact tech support.
            <!-- TBD error component. -->
          </b-alert>

          <!-- DENTAL EBOOKS -->
          <div class="div-section-header">
            <b-row>
              <b-col cols="12">
                <div>
                  <span class="txt-section-title">Dental eBooks</span>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="!noResults">
              <b-col cols="12">
                  <span class="txt-section-subtitle red">Available Now: {{totalRows | prettyNumber}} eBooks</span>
              </b-col>
            </b-row>
          </div>

          <b-alert v-model="noResults" class="mt-3" variant="info">
            No results found for this search.
          </b-alert>

          <!-- TBD bookList component. -->
          <div class="div-section-body" v-if="!noResults">

            <div v-for="(row,ix) in books" v-bind:key="ix">
              <b-row class="mt-3">
                <b-col cols="4">
                  <div class="text-center">
                    <b-img fluid v-bind:src="row.thumbnail" />
                  </div>
                </b-col>
                <b-col cols="8" style="margin-left: -20px;">
                    <div class="div-book-title">{{row.title}}</div>
                    <div class="div-book-subtitle">{{row.subtitle}}</div>
                </b-col>
              </b-row>
              <b-row class="mb-4">
                  <b-col cols="12">
                    <div class="div-book-blurb">
                        {{row.blurbLib}}
                    </div>
                    <div class="mt-1" style="color: red;">
                        <span v-if="isLoggedIn">Free</span>
                        <span v-if="!isLoggedIn">Free (must be logged in)</span>
                    </div>
                    <div class="mt-1">
                        <b-button type="button" variant="danger" @click.stop.prevent="submit(ix)">
                        <span class="text-nowrap">&nbsp;{{ row.buttonText || "Get eBook" }}&nbsp;</span>
                        <span style="font-size:60%;vertical-align: middle;">&nbsp;&#x25BA;</span>
                        </b-button>
                    </div>
                </b-col>
              </b-row>
              <hr style="width:90%;">
            </div>

          </div>

        </b-col>
      </b-row>

    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";
import utils from "@/utils/utils"

export default {
  name: "Ebooks",
  data() {
    return {
      debug: false,
      loading: true,
      error: false,
      studentHash: this.$root.getToken(),
      msg: "Dental eBooks",
      blurb: "eBooks: 0",
      books: [],
      totalRows: 0
    }
  },
  props: {
    page: {
      type:String,
      required: false,
      default: "1"
    }
  },
  computed: {
    isLoggedIn() {
        return this.$root.hasToken()
    },
    rows () {
      return this.books.length
    },
    noResults() {
      return (this.books.length == 0)
    }
  },
  methods: {
    submit(ix) {
        if (!this.isLoggedIn) {
            this.$router.push(`/login?rurl=/ebooks`)
            return
        }

        let book = this.books[ix]

        this.error = false
        this.success = false
        this.busy = true
        service
            .saveBookResponse({s: this.studentHash, h: book.hash})
            .then( res => {
                if (this.debug) console.log(res.data)
                if (res.status) {
                    console.log('success')
                    this.error = false
                    this.success = true
                } else {
                    this.success = false
                    this.errorMsg = res.errorMsg || 'System Error from Save Book Response.'
                    this.error = true
                }
            })
            .finally( () => {
                this.busy = false
                window.location = book.pdf
            })
            .catch(e => {
                console.log(e);
                this.error = true
            })
    },
    submitNewTab(ix) {
        if (!this.isLoggedIn) {
            this.$router.push(`/login?rurl=/ebooks`)
            return
        }

        let book = this.books[ix]

        this.error = false
        this.success = false
        this.busy = true
        service
            .saveBookResponse({s: this.studentHash, h: book.hash})
            .then( res => {
                if (this.debug) console.log(res.data)
                if (res.status) {
                    console.log('success')
                    this.error = false
                    this.success = true
                } else {
                    this.success = false
                    this.errorMsg = res.errorMsg || 'System Error from Save Book Response.'
                    this.error = true
                }
            })
            .finally( () => {
                this.busy = false
                let win = window.open(book.pdf, '_blank')
                if (win) win.focus()
            })
            .catch(e => {
                console.log(e);
                this.error = true
            })
    },
    doEbooks() {
      this.loading = true
      this.books = []
      service
        .getBooks(this.studentHash)
        .then(res => {
          if (this.debug) console.log(res);
          if (res.status && res.rowCount !== 0) {
            this.blurb = `Dental eBooks: ${res.rowCount}`
            this.books = res.data
            this.totalRows = res.rowCount
          } else {
            this.blurb = "No ebooks found.";
          }
        })
        .finally(() => this.loading = false)
        .catch(e => console.log(e));
    }
  },
  created() {
    this.doEbooks()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .div-book-title {
        color: #0d78c0;
        font-size: 1.08rem;
        font-weight: bold;
        line-height: 125%;
    }
    .div-book-subtitle {
        color: #000;
        font-size: .9rem;
        font-weight: bold;
        line-height: 125%;
        margin-top: 5px;
    }
    .div-book-blurb {
        color: #000;
        margin-top: 10px;
    }
    .btn-view-ebook {
        min-width: 75px;
        height: 28px;
        border: 0px;
        margin: 0px;
        background-color: #2165af;
        color: #fff;
        font-weight: 500;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Ebooks.vue